import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { ILoginRequest } from '../../models/api/request/auth.request';
import { Observable } from 'rxjs';
import { IApiResponse } from '../../models/api/api';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  jsonPath: string = '/json/moke.json';

  constructor(
    private httpClient: HttpClient
  ) { }

  login(req: ILoginRequest): Observable<IApiResponse<any>> {
    return this.httpClient.get<IApiResponse<any>>(this.jsonPath);
  }

  register() {

  }

  getKundaliList() {
    return this.httpClient.get<IApiResponse<any>>(this.jsonPath);
  }
}
